import { CSSProperties } from 'react';
import styled from 'styled-components';
import MarkdownBase, { Options } from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownProps extends Options {
  dir?: 'auto' | 'ltr' | 'rtl';
  style?: CSSProperties;
}

const MarkdownStyled = styled(MarkdownBase)<{ $fontSize?: string }>`
  font-size: ${({ $fontSize }) => $fontSize || '14px'};
  color: ${({ theme }) => theme.palette.common.black};

  p {
    margin: 0;
    line-height: 1.5;
  }

  a {
    color: ${({ theme }) => theme.palette.common.blue};
  }

  ul,
  ol {
    line-height: 1.5;
  }

  code {
    font-family: 'Geist Mono', monospace;
    background: ${({ theme }) => theme.palette.common.gray5};
    color: ${({ theme }) => theme.palette.common.gray12};
    padding: 0 4px;
    border-radius: 2px;
    white-space: pre-wrap;
  }
`;

const Markdown = (props: MarkdownProps) => (
  <MarkdownStyled {...props} remarkPlugins={[remarkGfm]} />
);

export default Markdown;
